const employerPOCQuery = (id) => {
    return `
    query {
        getPOCById(id: "${id}") {
          id
          group_id,
          form_id,
          user_id,
          employer_id,
          POCFormData {
            poc_emp_last_name
            poc_emp_first_name
            poc_emp_middle_name
            poc_emp_job_title
            poc_emp_address1
            poc_emp_address2
            poc_emp_city
            poc_emp_state_id
            poc_emp_zip
            poc_emp_country_id
            poc_emp_province
            poc_emp_phone
            poc_emp_phone_ext
            poc_emp_email
            poc_emp_profile_name
          }
        }
      }
      `
}

export default employerPOCQuery